// A small fuzzy match for the command palette: every character of the query in order; earlier, word-start and
// consecutive matches score higher. Returns null when it doesn't match.
export function fuzzyScore(query: string, text: string): number | null {
  const q = query.trim().toLowerCase();
  if (!q) return 0;
  const t = text.toLowerCase();
  let score = 0, ti = 0, last = -2;
  for (const ch of q) {
    if (ch === " ") continue;
    const at = t.indexOf(ch, ti);
    if (at < 0) return null;
    score += 1;
    if (at === last + 1) score += 3;                         // consecutive
    if (at === 0 || /[\s\-/(]/.test(t[at - 1])) score += 4;  // start of a word
    score -= Math.min(at - ti, 5) * 0.2;                     // gaps cost a little
    last = at; ti = at + 1;
  }
  if (t.startsWith(q)) score += 5;
  return score;
}

export function fuzzyFilter<T>(items: T[], query: string, text: (item: T) => string, limit = 12): T[] {
  return items
    .map((item) => ({ item, s: fuzzyScore(query, text(item)) }))
    .filter((x): x is { item: T; s: number } => x.s !== null)
    .sort((a, b) => b.s - a.s)
    .slice(0, limit)
    .map((x) => x.item);
}
